import { render, staticRenderFns } from "./merged-record-display.vue?vue&type=template&id=3b122aa3&scoped=true"
import script from "./merged-record-display.vue?vue&type=script&lang=js"
export * from "./merged-record-display.vue?vue&type=script&lang=js"
import style0 from "./merged-record-display.vue?vue&type=style&index=0&id=3b122aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b122aa3",
  null
  
)

export default component.exports